import PostEditor from "./PostEditor";

export default PostEditor;
